<p-autocomplete [ngModel]="displayValue()" (ngModelChange)="onModelChange($event)" [suggestions]="filteredTypes()"
    (completeMethod)="searchTypes($event)" (onSelect)="onTypeSelect($event)" [dropdown]="true" dropdownMode="current"
    [forceSelection]="false" [minLength]="minLength" [placeholder]="placeholder()" [disabled]="disabled()"
    styleClass="w-full text-sm">
    <ng-template let-type pTemplate="item">
        <div class="flex flex-col">
            <span class="font-medium">{{type.name}}</span>
            <span *ngIf="type.id && type.name" class="text-xs text-gray-500">{{type.id}}</span>
        </div>
    </ng-template>
</p-autocomplete>